import { Layout } from "../shared/components/Layout";
import styles from "./ServersSearchPage.module.scss"; 
import { background } from "../assets/images";
import Gallery from "../features/server-search/Gallery";
import SearchForm from "../shared/components/SearchForm/SearchForm";
import { HeaderVariant } from "../shared/components/Header/types";

export default function ServersSearchPage() {
  return (
    <Layout
      customMainClass={styles.searchMain}
      background={background}
      customPlaceholder={styles.placeholder}
      showFooter
      headerVariant={HeaderVariant.Brown30BlackWhiteLogo}
    >
      <div className={styles.container}>
        <SearchForm
        mode="server"
          headerText="Найди нужный сервер"
          buttonText="Выбрать"
          popupTitles={{
            loadingServers: "Загрузка серверов...",
            loadingSelect: "Загрузка данных...",
          }}
        />
        <Gallery />
      </div>
    </Layout>
  );
}